import { Component, OnInit, Inject } from '@angular/core';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {TranslateService} from '@ngx-translate/core';
import {MatTableDataSource} from '@angular/material/table';
import { SurveyStatusV2Service } from "app/main/pagina/tools/survey-status-v2/survey-status-v2.service";
@Component({
  selector: 'app-survey-check',
  templateUrl: './survey-check.component.html',
  styleUrls: ['./survey-check.component.scss']
})
export class SurveyCheckComponent implements OnInit {
  idiomaActual:string;
  displayedColumns: string[] = ['section', 'value'];
  tablaDatos:any;
  cargando:boolean=true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private surveyServ: SurveyStatusV2Service,
    public dialogRef: MatDialogRef<SurveyCheckComponent>,
    private translateSrv: TranslateService,
  ) {
    this.idiomaActual = this.translateSrv.currentLang;
    this.translateSrv.onLangChange.subscribe(() => { this.idiomaActual = this.translateSrv.currentLang; });
  }

  ngOnInit() {
    let token= localStorage.getItem('TokenSurvey');
    console.log(this.data.datos);
    if (this.data.tipoModa=='surveyCheck') {
      this.surveyCheckInfo(token);
    }else{
      this.cargarTabla();
    }
  }

  cargarTablaSurvey(datosSurvey){
    this.cargando=false;
    this.tablaDatos= new MatTableDataSource(datosSurvey);
  }
  cargarTabla(){
    this.cargando=false;
    this.tablaDatos= new MatTableDataSource(this.data.datos);
  }

  buscaColumna(filtro: string){
    this.tablaDatos.filter = filtro.trim().toLowerCase();
  }

  salir() {
    this.dialogRef.close();
  }

  surveyCheckInfo(token){
    this.surveyServ.surveyCheck(token).subscribe((respuesta:any) => {
      console.log("surveyCheck:",respuesta);
          this.cargarTablaSurvey(respuesta.result);
    }, error  => {
      console.log("error");
    });

  }

}
